module.exports = {
      id: "virtual-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#virtual-usage",
      toString: function () {
        return this.url;
      }
    }